import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Paper, RaisedButton, CircularProgress } from 'material-ui';
import { getMarketingMaterials, updateMMProps, updateMMPartnerProps, editMMField, clearStore } from '../../stores/marketing-materials/actions';
import DropzoneWithPreview from '../extra/dropzone-with-preview/dropzone';
import DragDropContainer from './drag-drop/drag-drop-container';
import { equals, prop, merge, propOr, isEmpty, not, path, without, contains, flatten, uniq, always, T, cond, call, ifElse } from 'ramda';
import { browser } from 'bowser';
import TitleContainer from './title-bar/title-container';
import UnsupportedBrowserDialog from './unsupported-browser';
import SendToPartners from './send-to-partners/container-send-to-partners';
import SearchBar from './search-bar';
import Tags from './tags';
import { multiDownload } from '../../utils/multi-download';
import InsertPhotoIcon from 'material-ui/svg-icons/editor/insert-photo';

class MarketingMaterials extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showSafariErrorForMultiFiles: false,
    };
    // for viewers
    if (!this.props.isEditable) {
      this.state = {
        selectedFiles: [],
        filteredMedia: [],
        filterByMediaType: 'All File Types',
        hovering: false,
        previewDialog: false,
        selectedFileIndex: 0,
      };
    }
  }

  componentWillMount() {
    this.getMMData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.routeName !== nextProps.routeName || this.props.params.companyId !== nextProps.params.companyId) this.getMMData(nextProps);
  }

  componentWillUnmount() {
    this.props.clearReducer();
  }

  getMMData = (props) => {
    const { user, getMM, routeName, updateMMProp, params, isEditable, companyProfileReducer, companyLocationReducer, companyProductReducer } = props;
    const checkRoute = call(cond([
      [equals('profile'), always(params.companyId || prop(0, Object.keys(companyProfileReducer)))],
      [equals('location'), always(path([params.locationId, 'companyId'], companyLocationReducer))],
      [equals('product'), always(path([params.productId, 'companyId'], companyProductReducer))],
    ]), routeName);
    const getCompanyId = isEditable ? path(['user', 'userID'], user) : checkRoute || path(['user', 'userID'], user);
    getMM(getCompanyId);
    if (routeName && !equals(routeName, 'profile')) {
      updateMMProp({
        managingTags: false,
        selectedFiles: [],
        tagsStep: 1,
        tags: [],
      });
    }
    if (equals(routeName, 'profile')) {
      updateMMProp({
        selectedFiles: [],
      });
    }
  };

  updateMM = options => {
    const { updateMMProp, saveMMField } = this.props;
    updateMMProp({
      [options.updateField]: options.updateBody,
      savingMedia: false,
    });
    saveMMField(options);
  };

  render() {
    const {
      updateMMProp,
      updateMMPartnerProp,
      isEditable,
      MMReducer,
      MMPartnerReducer,
      isSupplier,
      forLocationOrProductPages, // only for location and product pages
      findPhotosForTag,  // only for location and product pages
      isOneLocationSupplier,
      profileLocationReducer,
      params,
      routeName,
    } = this.props;

    const selectedFilesUrls = isEditable ? propOr([], 'selectedFiles', MMReducer).map(file => file.url) : propOr([], 'selectedFiles', this.state);

    // const convertFileToBlob = (url, callback) => {
    //   const xhr = new XMLHttpRequest();
    //   xhr.onload = () => {
    //     const reader = new FileReader();
    //     reader.onloadend = () => {
    //       callback(reader.result);
    //     };
    //     reader.readAsDataURL(xhr.response);
    //   };
    //   xhr.open('GET', url);
    //   xhr.responseType = 'blob';
    //   xhr.send();
    // };

    const generateATag = (browserName, url, fileName, fileType, base64String) => {
      const link = document.createElement('a');
      link.setAttribute('download', fileName);
      link.style.display = 'none';
      document.body.appendChild(link);
      link.setAttribute('href', equals(browserName, 'Firefox') ? base64String : `/proxy/s3/file?key=${encodeURIComponent(url)}`);
      // powerpoints will download correctly
      if ((equals(browserName, 'Safari') || equals(browserName, 'Internet Explorer')) && !equals(fileType, 'application/vnd.ms-powerpoint') && !equals(fileType, 'application/vnd.openxmlformats-officedocument.presentationml.presentation')) link.setAttribute('target', '_blank');
      link.click();
      document.body.removeChild(link);
    };

    const downloadSingleFile = (files) => {
      if (equals(browser.name, 'Safari') || equals(browser.name, 'Internet Explorer') || equals(browser.name, 'Firefox')) {
        if (equals(prop('length', files), 1)) return generateATag('Safari', path([0, 'url'], files), path([0, 'fileName'], files), path([0, 'fileType'], files));
        if (prop('length', files) > 1) this.setState({ showSafariErrorForMultiFiles: true });
      } else {
        if (equals(prop('length', files), 1)) return generateATag(undefined, path([0, 'url'], files), path([0, 'fileName'], files));
        return multiDownload(files);
      }
    };

    const sharedProps = {
      updateMMProp,
      isSupplier,
    };

    const propsForTitleAndDragDrop = merge(sharedProps, {
      downloadSingleFile,
      updateMM: this.updateMM,
      selectedFilesUrls,
    });

    const propsForViewers = {
      containerStateForViewers: !isEditable ? this.state : undefined,
      updateStateForViewers: !isEditable ? (key, field) => this.setState({ [key]: field }) : undefined,
    };

    return (
      <div id="marketing-materials">
        <Paper
          rounded={false}
          zDepth={1}
          style={{ marginTop: '3%', padding: (isSupplier || MMPartnerReducer.sendToPartners) ? '' : '3% 5%' }}
        >
          <div>
            <TitleContainer
              updateMMPartnerProp={updateMMPartnerProp}
              isEditable={isEditable}
              forLocationOrProductPages={forLocationOrProductPages}
              findPhotosForTag={findPhotosForTag}
              {...propsForViewers}
              {...propsForTitleAndDragDrop}
            />
            <div style={{ clear: 'both', padding: '2% 5%' }}>
              {
                isEditable && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM && !MMReducer.managingTags ?
                  (
                    <div>
                      {(!findPhotosForTag.length && isEditable) && (
                        <div
                          style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}
                        >
                          <InsertPhotoIcon style={{ color: 'rgba(0, 0, 0, 0.54)' }} />
                          Make a great first impression...add some beautiful images here!
                        </div>)}
                      <DropzoneWithPreview
                        addFilesMessage="Add Marketing Materials by clicking here."
                        acceptedFileTypes=".jpg, .png, .jpeg, .mp4, .ppt, .pptx, .pdf"
                        arrayOfPhotoTypes={[
                          'image/jpeg',
                          'image/png',
                        ]}
                        arrayOfAcceptedFileTypes={[
                          'image/jpeg',
                          'image/png',
                          'video/mp4',
                          'application/vnd.ms-powerpoint',
                          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                          'application/pdf']}
                        addRemoveLinks={false}
                        showFiletypeIcon={false}
                        allFiles={(MMReducer.media || [])}
                        showThumbnailPreviews={false}
                        uploadingFile={() => updateMMProp({ uploadingFile: true })}
                        suggestedMinFileSize="50"
                        finishedFileUploadCB={(imageUrl, fileType, fileName, fileSize) => {
                          const tagIDToFind = call(ifElse(
                            equals(true),
                            () => call(ifElse(
                              equals(true),
                              always(params.locationId),
                              always(params.productId)
                            ), Boolean(params.locationId)),
                            always(undefined)
                          ), routeName !== 'profile');
                          MMReducer.media.unshift({
                            url: imageUrl,
                            mediaType: fileType,
                            name: fileName,
                            size: fileSize,
                            tags: call(cond([
                              [equals(true), () => call(ifElse(
                                equals(true),
                                always([Object.keys(profileLocationReducer).pop()]),
                                always([tagIDToFind])
                              ), isOneLocationSupplier && routeName === 'profile')],
                              [T, always([])],
                            ]), (isOneLocationSupplier || forLocationOrProductPages)),
                            created_at: new Date(),
                          });
                          updateMMProp({
                            savingMedia: true,
                            media: MMReducer.media,
                            uploadingFile: false,
                          });
                          this.updateMM({
                            updateField: 'media',
                            updateBody: MMReducer.media,
                          });
                        }}
                      />
                    </div>
                  ) : <span/>
              }
              {not(isEmpty(MMReducer.media)) && isEditable && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM && !MMReducer.managingTags ?
                <SearchBar
                  value={isEditable ? MMReducer.searchField : this.state.searchField}
                  onChangeFunc={({ target: { value } }) => {
                    const fileNameSearch = MMReducer.media.map(file => file.name.toLowerCase()).filter(fileName => contains(value.toLowerCase(), fileName));
                    const findTags = isSupplier ? flatten(MMReducer.media.map(file => {
                      const results = [];
                      const tagNames = file.tags.reduce((acc, tag) => {
                        const tagName = MMReducer.productTags.concat(MMReducer.locationTags).filter(obj => obj.id === tag)[0];
                        acc.push(tagName);
                        return acc;
                      }, []);
                      tagNames.map(tagObj => tagObj.name).map(tagName => {
                        if (contains(value.toLowerCase(), tagName.toLowerCase())) results.push(file);
                      });
                      return results;
                    })) : [];
                    if (isEditable) {
                      updateMMProp({
                        selectedFiles: [],
                        filterByMediaType: 'All File Types',
                        searchField: value,
                        filteredMedia: uniq(MMReducer.media.filter(file => contains(file.name.toLowerCase(), fileNameSearch)).concat(findTags)),
                      });
                    } else {
                      this.setState({
                        filterByMediaType: 'All File Types',
                        searchField: value,
                        filteredMedia: uniq(findTags),
                        selectedFiles: [],
                      });
                    }
                  }}
                  isSupplier={isSupplier}
                  isEditable={isEditable}
                /> : <span/>}
              {
                MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM ?
                  <SendToPartners
                    updateMMPartnerProp={updateMMPartnerProp}
                    isSupplier={isSupplier}
                  /> : <span/>
              }
              {
                MMReducer.managingTags ?
                  <Tags
                    updateMMProp={updateMMProp}
                  /> : <span/>
              }
              <div
                className={MMReducer.managingTags && equals(MMReducer.tagsStep, 1) ? 'blur-photos' : ''}
                style={{ clear: 'both', textAlign: 'center', marginTop: '10px', border: MMReducer.managingTags && equals(MMReducer.tagsStep, 2) ? '1px solid #d3d3d3' : '', padding: MMReducer.managingTags ? '10px' : '' }}
              >
                {
                  MMReducer.managingTags ?
                    <div style={{ textAlign: 'left', marginBottom: '15px' }}>
                      <b>Step Two:</b> Select which files you would like to assign {equals(MMReducer.tags.length, 1) ? 'the tag' : 'tags'} to. Deselecting a file will remove the tag from the location / product.
                    </div> : <span/>
                }
                {
                  not(isEmpty(MMReducer.media)) && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM ? (
                    <div style={{ maxHeight: '500px', overflowY: 'scroll', overflowX: 'hidden', pointerEvents: MMReducer.managingTags && equals(MMReducer.tagsStep, 1) ? 'none' : '' }}>
                      {
                        MMReducer.loadingMM ? (<CircularProgress />) :
                          (<DragDropContainer
                            isEditable={isEditable}
                            forLocationOrProductPages={forLocationOrProductPages}
                            findPhotosForTag={findPhotosForTag}
                            {...propsForViewers}
                            {...propsForTitleAndDragDrop}
                          />)
                      }
                    </div>
                  ) : <span/>
                }
                {
                  MMReducer.managingTags ?
                    <div style={{ display: 'block', textAlign: 'right', marginTop: '10px' }}>
                      <RaisedButton
                        key="MMSaveButton"
                        label="Save"
                        onTouchTap={() => {
                          const addIndex = MMReducer.media.map((obj, index) => merge(obj, { index }));
                          const selectedIndexes = MMReducer.selectedFiles.map(obj => {
                            const allUrls = addIndex.map(file => file.url);
                            if (contains(obj.url, allUrls)) return addIndex.filter(object => object.url === obj.url)[0].index;
                          });
                          const originalFilesWithTags = addIndex.filter(obj => {
                            if (MMReducer.tags.every(i => obj.tags.indexOf(i) !== -1)) return obj;
                          }).map(obj => obj.index);
                          const removeTagsFrom = originalFilesWithTags.filter(i => selectedIndexes.indexOf(i) < 0);
                          const addTagsTo = selectedIndexes.filter(i => originalFilesWithTags.indexOf(i) < 0);
                          addTagsTo.map(index => MMReducer.media[index].tags = MMReducer.media[index].tags.concat(MMReducer.tags));
                          removeTagsFrom.map(index => MMReducer.media[index].tags = without(MMReducer.tags, MMReducer.media[index].tags));
                          this.updateMM({
                            updateField: 'media',
                            updateBody: MMReducer.media,
                          });
                          updateMMProp({
                            media: MMReducer.media,
                            tagsStep: 1,
                            managingTags: false,
                            tags: [],
                            selectedFiles: [],
                          });
                        }}
                        secondary
                      />
                    </div> : <span/>
                }
              </div>
            </div>
          </div>
        </Paper>
        {
          this.state.showSafariErrorForMultiFiles ?
            <UnsupportedBrowserDialog
              buttonText="OK"
              confirmationFunc={() => this.setState({ showSafariErrorForMultiFiles: false })}
              title="Unsupported Browser"
              errorMessage="The browser you are using is not supported for multiple downloads. Please use Chrome."
            /> : <span/>
        }
      </div>
    );
  }
}

const mapStateToProps = ({ marketingMaterials, profileLocation, user, companyProfile, companyLocation, companyProduct }) => ({
  MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
  MMReducer: marketingMaterials.mainReducer.toJS(),
  profileLocationReducer: profileLocation.toJS(),
  companyProfileReducer: companyProfile.toJS(),
  companyLocationReducer: companyLocation.toJS(),
  companyProductReducer: companyProduct.toJS(),
  user: user.toJS(),
});

const mapDispatchToProps = dispatch => ({
  getMM: companyId => dispatch(getMarketingMaterials(companyId)),
  updateMMProp: (...args) => dispatch(updateMMProps(...args)),
  updateMMPartnerProp: (...args) => dispatch(updateMMPartnerProps(...args)),
  saveMMField: (...args) => dispatch(editMMField(...args)),
  clearReducer: () => dispatch(clearStore()),
});

MarketingMaterials.propTypes = {
  saveMMField: PropTypes.func,
  updateMMProp: PropTypes.func,
  updateMMPartnerProp: PropTypes.func,
  isEditable: PropTypes.bool,
  MMReducer: PropTypes.object,
  MMPartnerReducer: PropTypes.object,
  dispatch: PropTypes.func,
  user: PropTypes.object,
  getMM: PropTypes.func,
  isSupplier: PropTypes.bool,
  forLocationOrProductPages: PropTypes.bool,
  findPhotosForTag: PropTypes.array,
  routeName: PropTypes.string,
  isOneLocationSupplier: PropTypes.bool,
  profileLocationReducer: PropTypes.object,
  params: PropTypes.object,
  clearReducer: PropTypes.func,
  companyProfileReducer: PropTypes.object,
  companyLocationReducer: PropTypes.object,
  companyProductReducer: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketingMaterials);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/container.jsx